import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Typography } from '@material-ui/core';
import MessagePresenter from 'presenters/MessagePresenter';

import useStyles from './useStyles';

const TextMessage = props => {
  const classes = useStyles();
  const { message, isCurrentUserMessage, isFirstMessage } = props;

  return (
    <div className={classes.root}>
      <div className={clsx(classes.container, { [classes.dark]: isCurrentUserMessage })}>
        <Typography variant="body2" className={isFirstMessage ? classes.textFirst : classes.text} color="inherit">
          {MessagePresenter.data(message)}
        </Typography>
      </div>
    </div>
  );
};

TextMessage.propTypes = {
  message: MessagePresenter.shape().isRequired,
  isCurrentUserMessage: PropTypes.bool.isRequired,
};

export default TextMessage;



// WEBPACK FOOTER //
// ./src/sharedComponents/Chat/components/Messages/components/Message/components/TextMessage/TextMessage.js